import {
	JSON_FORM,
	REGULAR_FORM,
	END,
	NEXT,
	TOGGLE_JSON_TREE,
	NEXT_JSONTREE_QUESTION,
	UPDATE_LAST_ANSWERED_QUESTIONS,
} from '#app/constants/forms.ts'
import { type Action } from '#types/form/wizard.ts'

interface CurrentAnswer {
	[key: string]: string
}

interface CommonNextQuestionDispatcherState<T> {
	type: string

	currentFormContext: CurrentAnswer
	dispatch: React.Dispatch<Action<T>>
	fieldKey: string
	isLastStep: boolean
}

interface RegularFormParams<T> extends CommonNextQuestionDispatcherState<T> {
	type: typeof REGULAR_FORM
}

interface JSONFormParams<T> extends CommonNextQuestionDispatcherState<T> {
	type: typeof JSON_FORM
	isInJsonTree: boolean
	currentQuestionId: string
	currentQuestionTreeId: string
	nextQuestionId?: string
}
type SetNextQuestionDispatcherParams<T> =
	| RegularFormParams<T>
	| JSONFormParams<T>

export function setNextQuestionDispatcher<T>({
	type,
	currentFormContext,
	fieldKey,
	isLastStep,
	dispatch,
	...rest
}: SetNextQuestionDispatcherParams<T>) {
	const dispatchNextAction = () => {
		dispatch({
			type: NEXT,
			formData: currentFormContext as Partial<T>,
			fieldKey,
		})
	}

	if (
		(type === REGULAR_FORM && !isLastStep) ||
		(type === JSON_FORM && 'isInJsonTree' in rest && !rest.isInJsonTree)
	) {
		dispatchNextAction()
		return
	}

	if (type === JSON_FORM && 'isInJsonTree' in rest && rest.isInJsonTree) {
		const jsonParams = rest as JSONFormParams<T>
		const { nextQuestionId, currentQuestionId, currentQuestionTreeId } =
			jsonParams

		if (nextQuestionId === END) {
			dispatch({ type: TOGGLE_JSON_TREE, isInJsonTree: false })
			dispatch({
				type: UPDATE_LAST_ANSWERED_QUESTIONS,
				currentQuestionId,
				currentQuestionTreeId,
			})
			dispatchNextAction()
		}

		if (nextQuestionId) {
			dispatch({
				type: NEXT_JSONTREE_QUESTION,
				nextQuestionId,
				currentQuestionId: currentQuestionId as string,
				currentQuestionTreeId,
				formData: currentFormContext as Partial<T>,
			})
		}
	}
}
